import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { NewGoodsProposalModel } from "../vo/new-goods-proposal.model";
import { KYMW6901MasterInputTabModel } from "../../kymw6901-master-input-tab/kymw6901-master-input-tab.model";
import { KYMW6901Component } from "../../kymw6901.component";

interface NewGoodsProposal {
  JanCode: string;
  ProposalGoodsName: string;
  ProposalName: string;
  ClassCode: string;
  SuggestedPriceSellingNormal: string;
  SuggestedPriceSellingSpecial1: string;
  SuggestedPriceSellingSpecial2: string;
  SuggestedPricePurchaseNormal: string;
  SuggestedPricePurchaseSpecial1: string;
  SuggestedPricePurchaseSpecial2: string;
  ConsumeByDate: string;
  ConsumeTerm: string;
  CoopCode: string[];
}
type GetNewGoodsProposalResponse = NewGoodsProposal;

/**
 * 新規商品提案情報を取得するサービス
 *
 * @export GetNewGoodsProposalService
 * @class GetNewGoodsProposalService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNewGoodsProposalService extends PlessJsonResponderSub<GetNewGoodsProposalResponse> {
  private proposalId = '';
  private model: KYMW6901MasterInputTabModel;
  private successFunc: (newGoodsProposal: NewGoodsProposalModel) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetNewGoodsProposalService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProposalId: this.proposalId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetNewGoodsProposalService
   */
  execute(
    proposalId: string,
    model: KYMW6901MasterInputTabModel,
    successFunc: (newGoodsProposal: NewGoodsProposalModel) => void
  ) {
    this.proposalId = proposalId;
    this.model = model;
    this.successFunc = successFunc;
    this.send('getNewGoodsProposal', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNewGoodsProposalService
   */
  success(data: GetNewGoodsProposalResponse) {
    const item = data;
    const result = new NewGoodsProposalModel(
      this.proposalId,
      item.ClassCode,
      item.ProposalGoodsName,
      item.ProposalName,
      item.JanCode,
      item.SuggestedPriceSellingNormal,
      item.SuggestedPriceSellingSpecial1,
      item.SuggestedPriceSellingSpecial2,
      item.SuggestedPricePurchaseNormal,
      item.SuggestedPricePurchaseSpecial1,
      item.SuggestedPricePurchaseSpecial2,
      item.ConsumeByDate,
      item.ConsumeTerm,
      this.model.toCoopMap(item.CoopCode),
    );
    if (this.successFunc) {
      this.successFunc(result);
    }
  }
}
